import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLandingPagesAppGroupIdCreateLandingPageAppCacheKeys: AllRouteEndpoints[] = [
  "/apps/app_group",
];
